import { render, staticRenderFns } from "./Praktikumsplaetze.vue?vue&type=template&id=3d9ec4de&"
import script from "./Praktikumsplaetze.vue?vue&type=script&lang=js&"
export * from "./Praktikumsplaetze.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports